import React from 'react';
import config from "../config";
import {withStyles} from '@material-ui/core/styles';
import {getMappedStatusText} from "../utilities";


function StatusChip(props) {
  const {classes, shift} = props;

  return (
    <div style={{borderColor: config.statusColorMap[shift.status], color: config.statusColorMap[shift.status]}}
         className={classes.status}>
      {getMappedStatusText(shift)}
    </div>
  )
}

const styles = (theme) => ({
    status: {
      ...theme.typography.body2,
      fontWeight: 'bold',
      padding: '4px 12px',
      borderRadius: '16px',
      border: '1px solid',
      color: theme.palette.primary.contrastText,
      textAlign: 'center',
      display: 'inline-block',
    },
  }
);

export default withStyles(styles)(StatusChip);


// WEBPACK FOOTER //
// ./src/parts/StatusChip.js